type StorageFactoryOptions<T> = {
  storageKey: string;
  defaultValue: T;
  storageType?: "local" | "session";
};

export const createStorageFactory = <T>(options: StorageFactoryOptions<T>) => {
  const { storageKey, defaultValue, storageType = "local" } = options;
  const storage = storageType === "local" ? localStorage : sessionStorage;
  const get = (): T => {
    try {
      const value = storage.getItem(storageKey);
      if (!value) return defaultValue;
      return JSON.parse(value) as T;
    } catch (error) {
      console.error(`Error getting ${storageKey} from ${storageType} storage`, error);
      return defaultValue;
    }
  };

  const set = (value: T) => {
    try {
      const serializedValue = JSON.stringify(value);
      const previousValue = get();
      if (previousValue !== serializedValue) {
        storage.setItem(storageKey, serializedValue);
      }
    } catch (error) {
      console.error(`Error setting ${storageKey} in ${storageType} storage`, error);
    }
  };

  return { get, set };
};
